import React from 'react';
import LegalPage from './LegalPage';

function Privacy() {
  return (
    <LegalPage title="Privacy Policy" effectiveDate="September 8, 2026">
      <p>
        This website, johnwest.com, is the personal site of John West. This policy explains what
        information the site handles when you visit and how that information is used. The short
        version is that the site collects very little.
      </p>

      <h2>Information the site collects</h2>
      <p>
        The site has no user accounts, no sign-up forms, no comments, and no newsletter. You can read
        every page without providing any personal information.
      </p>
      <p>
        When you load a page, the hosting provider records standard server logs. A log entry can
        include your IP address, the browser and operating system you use, the page you requested,
        and the time of the request. These logs help keep the site running and diagnose problems.
        They are kept for a limited period and are then discarded.
      </p>

      <h2>The email verification step</h2>
      <p>
        To reduce spam, the contact section hides the email address behind a short arithmetic
        question. When you answer, your browser sends the answer and a signed token to the server.
        The server checks the answer and, if it is correct, returns the address. The answer and the
        token are not stored, and the exchange is not linked to you.
      </p>

      <h2>Cookies and tracking</h2>
      <p>
        The site does not set cookies and does not use analytics, advertising networks, or
        tracking pixels. There is nothing to opt out of.
      </p>

      <h2>Third-party services</h2>
      <p>
        The site loads the Inter typeface from Google Fonts. When your browser fetches the font
        files, Google receives your IP address and standard request headers. Google's handling of
        that data is described in the Google Privacy Policy.
      </p>
      <p>
        The site is hosted on Fly.io, which processes network traffic and keeps the server logs
        described above under its own privacy terms.
      </p>
      <p>
        The site links to LinkedIn and may link to other external sites. Those sites have their own
        privacy practices, and this policy does not cover them.
      </p>

      <h2>How information is used</h2>
      <p>
        Server logs are used only to operate, secure, and troubleshoot the site. No information
        collected by the site is sold, rented, or shared for marketing purposes.
      </p>

      <h2>Children</h2>
      <p>
        The site is not directed at children under 13 and does not knowingly collect information
        from them.
      </p>

      <h2>Your rights</h2>
      <p>
        Depending on where you live, you may have rights to access, correct, or delete personal
        information about you. Because the site stores no personal information beyond transient
        server logs, there is usually nothing to act on. If you have a question or a request, use
        the contact details below.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        This policy may be updated from time to time. The effective date at the top of the page
        shows when it last changed. Continued use of the site after a change means you accept the
        updated policy.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about this policy can be sent through the{' '}
        <a href="/#contact">contact section</a> on the home page or by message on{' '}
        <a href="https://www.linkedin.com/in/johnwest72/" target="_blank" rel="noopener noreferrer">
          LinkedIn
        </a>
        .
      </p>
    </LegalPage>
  );
}

export default Privacy;
